export default function dealRaise(
  setDealRiver: any,
  setFlipCard: any,
  handleShowResult: (b: boolean) => void,
) {
  setDealRiver(true)
  setTimeout(() => {
    setFlipCard(true)
    handleShowResult(true)
  }, 1000)
}
